import type { IWorkTitleSummary } from "containers/Works/types";

const compactIsbn = (value: string) => value.replace(/[\s-]/g, "").toLowerCase();

export const titleSearchText = (title: IWorkTitleSummary) =>
    `${title.name ?? ""} ${title.ean13 ?? ""} ${title.formatTypeName ?? ""}`.trim();

export const titleSubtitle = (title: IWorkTitleSummary, ean13Label: string) => {
    const ean13 = title.ean13 ? `${ean13Label} · ${title.ean13}` : "";
    return [ean13, title.formatTypeName].filter(Boolean).join(" · ");
};

export const filterTitlesByQuery = (titles: IWorkTitleSummary[], query: string) => {
    const needle = query.trim().toLowerCase();
    if (!needle) return titles;
    const compactNeedle = compactIsbn(needle);
    return titles.filter((title) => {
        const name = (title.name ?? "").toLowerCase();
        const format = (title.formatTypeName ?? "").toLowerCase();
        const isbn = (title.ean13 ?? "").toLowerCase();
        return (
            name.includes(needle) ||
            format.includes(needle) ||
            isbn.includes(needle) ||
            compactIsbn(isbn).includes(compactNeedle)
        );
    });
};

export const titlesForStack = (selectedTitles: IWorkTitleSummary[], workTitles: IWorkTitleSummary[]) =>
    (selectedTitles.length ? selectedTitles : workTitles).slice(0, 3);

export const titlesFromCoveredIds = (ids: number[] | undefined, workTitles: IWorkTitleSummary[]) => {
    if (!ids?.length) return [];
    const byId = new Map(workTitles.map((title) => [title.id, title]));
    return ids.map((id) => byId.get(id)).filter((title): title is IWorkTitleSummary => !!title);
};

export const titlesForPicker = (selectedTitles: IWorkTitleSummary[], workTitles: IWorkTitleSummary[]) => {
    if (!selectedTitles.length) return workTitles;
    const listedIds = new Set(workTitles.map((title) => title.id));
    const missing = selectedTitles.filter((title) => !listedIds.has(title.id));
    return missing.length ? [...missing, ...workTitles] : workTitles;
};
